import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { ProductCatalogProvider } from "./ProductCatalogProvider";
import "./styles.css";
import "./styles-sunny-signal.css";
import "./styles-mock-three.css";
import "./styles-color-themes.css";
import "./styles-brands.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ProductCatalogProvider><App /></ProductCatalogProvider>
  </StrictMode>,
);
